import { render, staticRenderFns } from "./demo_contractManage_newList.vue?vue&type=template&id=3cc6bd96&scoped=true&"
import script from "./demo_contractManage_newList.vue?vue&type=script&lang=js&"
export * from "./demo_contractManage_newList.vue?vue&type=script&lang=js&"
import style0 from "./demo_contractManage_newList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./demo_contractManage_newList.vue?vue&type=style&index=1&id=3cc6bd96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc6bd96",
  null
  
)

export default component.exports